import type { IconData } from '@stacksjs/iconify-core'

export const arrowThickToBottom: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M336 176.005V16H176v160H56v38.623l199.8 200L456 214.637v-38.632Zm-80.174 193.371L94.616 208.005H208V48h96v160h113.361ZM56 464h400v32H56z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default arrowThickToBottom
